import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import getRedirectUrl from '../../utils/getRedirectUrl';
import { validateHost } from '../../../middleware/allowed-hosts';

const AllowedHostProvider = ({ children }) => {
  const [redirectUrl, setRedirectUrl] = useState(false);
  useEffect(() => {
    const allowedHosts = __ALLOWED_HOSTS__.split(',');
    if (!validateHost(window.location.hostname, allowedHosts)) {
      const url = getRedirectUrl(new URL(window.location.href), allowedHosts);
      setRedirectUrl(url);
    }
  }, []);

  return redirectUrl ? (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
      <meta httpEquiv="refresh" content={`0; url=${redirectUrl}`} />
    </Helmet>
  ) : children;
};

AllowedHostProvider.propTypes = {
  children: PropTypes.node,
};

export default AllowedHostProvider;
